<template>
    <div>
        <div v-if="!innerIsReview" class="mb-4">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                    :ref="'validate' + fieldAssignmentId"
                >
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <v-text-field
                        v-if="isSingle"
                        v-model="innerValue"
                        v-bind="[vProps, $attrs]"
                        :error-messages="errors"
                        :counter="counterValue"
                        :placeholder="placeholder"
                        v-on="$listeners"
                        hide-details="auto"
                    >
                        <template #label>
                            <span v-if="innerLabel" v-html="innerLabel"></span>
                        </template>
                        <slot
                            v-for="(_, name) in $slots"
                            :slot="name"
                            :name="name"
                        ></slot>
                        <template
                            v-for="(_, name) in $scopedSlots"
                            :slot="name"
                            slot-scope="slotData"
                            ><slot :name="name" v-bind="slotData"
                        /></template>
                    </v-text-field>
                    <v-textarea
                        v-else
                        v-model="innerValue"
                        v-bind="[vProps, $attrs]"
                        :error-messages="errors"
                        :counter="counterValue"
                        :placeholder="placeholder"
                        v-on="$listeners"
                        hide-details="auto"
                    >
                        <template #label>
                            <span v-if="innerLabel" v-html="innerLabel"></span>
                        </template>
                        <slot
                            v-for="(_, name) in $slots"
                            :slot="name"
                            :name="name"
                        />
                        <template
                            v-for="(_, name) in $scopedSlots"
                            :slot="name"
                            slot-scope="slotData"
                            ><slot :name="name" v-bind="slotData"
                        /></template>
                    </v-textarea>
                </validation-provider>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
// TODO: more validation

export default {
    name: 'TypeTextBox',
    mixins: [formMixin],
    inheritAttrs: false,
    components: {
        TypeReview
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        counterValue() {
            if (!this.validation_settings) return undefined;
            else if (this.validation_settings.maxlength)
                return this.validation_settings.maxlength;
            else if (this.validation_settings.minlength) return true;
            return undefined;
        },
        isSingle() {
            return (
                this.type.replace(' ', '') === 'TextBox' &&
                this.type_attributes.indexOf('Single Line') > -1
            );
        }
    }
};
</script>
